(() => {
  document.addEventListener("DOMContentLoaded", () => {

    if (!document.body.classList.contains("biga-home-v2")) return;

    const wrap = document.querySelector(".biga-v2__wrap");
    if (!wrap) return;

    const START_INSET = 22;
    const END_INSET = 0;

    function update() {
      const rect = wrap.getBoundingClientRect();
      const vh = window.innerHeight;

      // quando entra → inizia ad aprirsi
      const progress = Math.min(
        Math.max((vh - rect.top) / (vh * 0.8), 0),
        1
      );

      const inset = START_INSET + (END_INSET - START_INSET) * progress;
      wrap.style.setProperty("--inset", inset + "vw");
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    update();
  });
})();
